<script setup>
import { watch, reactive, ref, onMounted } from "vue";
import { apiQuery } from "@/api/j24api";

const loading = ref(true);
const users = reactive([]);
const editUserRecord = reactive({
  _id: "",
  email: "",
  username: "",
  roles: [],
  permissions: [],
});

const editUser = ref(false);
const newUser = ref(false);

const permissions = reactive([]);
const permissionsFiltered = reactive([]);
const customers = reactive([]);
const apps = reactive([]);
const userAccounts = reactive([]);

const addPermission = ref(false);
const addPermissionApp = ref("");
const addPermissionScope = ref("");
const addPermissionSelected = ref("");
const addPermissionActions = ref([]);
const addPermissionSelectedActions = ref([]);

const addRole = ref(false);
const addRoleScope = ref("");
const addRoleSelected = ref("");

const roles = reactive([]);

function getRoleName(id) {
  var roleName = "Role Not Found (has it been deleted?)";
  roles.forEach((role) => {
    if (role._id == id) {
      roleName = role.name;
    }
  });
  return roleName;
}

async function getUsers() {
  loading.value = true;
  try {
    const result = await apiQuery("J24Auth", "users", { apiAction: "get" });
    users.length = 0;
    users.push(...result);
  } catch (error) {
    console.log(error);
  }
  loading.value = false;
}

async function getPermissionsCustomers() {
  permissions.length = 0;
  var result = await apiQuery("J24Auth", "getpermission", "");
  const tempApps = [];
  for (const key in result) {
    result[key].value = result[key].permissionName;
    result[key].title = result[key].permissionName;
    tempApps.push(result[key].app);
  }
  permissions.push(...result);

  apps.length = 0;
  apps.push(...new Set(tempApps));
  customers.length = 0;
  result = await apiQuery("J24Auth", "customers", { apiAction: "get" });
  for (const key in result) {
    result[key].value = result[key].name;
    result[key].title = result[key].name;
  }
  customers.push({ value: "*", title: "* (All Customers)" });
  customers.push(...result);
}

watch(addPermissionApp, (currentValue) => {
  console.log("Filtering Permissions");
  permissionsFiltered.length = 0;
  for (const key in permissions) {
    if (permissions[key].app == currentValue) {
      permissionsFiltered.push(permissions[key]);
    }
  }
});

watch(addPermissionSelected, (currentValue) => {
  console.log("Filtering Actions");
  addPermissionActions.value.length = 0;
  for (const key in permissions) {
    if (
      permissions[key].app == addPermissionApp.value &&
      permissions[key].permissionName == currentValue
    ) {
      addPermissionActions.value.push(...permissions[key].actions);
    }
  }
});

const selectedUser = ref("");
const showSelectUser = ref(false);

watch(selectedUser, (currentValue) => {
  console.log(currentValue);
  if (currentValue == "") {
    return;
  }
  editUserRecord.username = currentValue;
  showSelectUser.value = false;
  // editUserRecord.email = userAccounts.filter(
  //   (user) => user.Username == currentValue
  // );
  userAccounts.forEach((user) => {
    if (user.Username == currentValue) {
      console.log("Setting edituserrecord email");
      editUserRecord.email = user.email;
      editUserRecord.UserStatus = user.UserStatus;
      editUserRecord.email_verified = user.email_verified;
    }
  });
});

function addPermissionSave() {
  // Add to editUserRecord.permissions

  editUserRecord.permissions.push({
    app: addPermissionApp.value,
    permissionName: addPermissionSelected.value,
    actions: [...addPermissionSelectedActions.value],
    scope: addPermissionScope.value,
  });
  addPermissionApp.value = "";
  addPermissionSelected.value = "";
  addPermissionSelectedActions.value.length = 0;
  addPermissionScope.value = "";
  addPermission.value = false;
}

async function getRoles() {
  const result = await apiQuery("J24Auth", "roles", { apiAction: "get" });
  roles.length = 0;
  for (const key in result) {
    result[key].title = result[key].name;
    result[key].value = result[key].name;
  }
  roles.push(...result);
}

function addRoleSave() {
  // Get ID of Role Selected
  var roleID;
  roles.forEach((role) => {
    if (role.name == addRoleSelected.value) {
      roleID = role._id;
    }
  });
  editUserRecord.roles.push({ roleID: roleID, scope: addRoleScope });
}

async function newUserPressed(key) {
  loading.value = true;
  delete editUserRecord._id;
  // await getPermissionsCustomers();
  // await getUserAccounts();
  const response = await Promise.all([
    getPermissionsCustomers(),
    getUserAccounts(),
  ]);
  newUser.value = true;
  loading.value = false;
  showSelectUser.value = true;
}

async function editUserPressed(key) {
  loading.value = true;
  editUserRecord._id = users[key]._id;
  editUserRecord.email = users[key].email;
  editUserRecord.roles.push(...users[key].roles);
  editUserRecord.permissions.push(...users[key].permissions);
  editUser.value = true;
  await getPermissionsCustomers();
  //await getRoles();
  loading.value = false;
}

function cancelEditAdd() {
  editUserRecord._id = "";
  editUserRecord.email = "";
  editUserRecord.roles.length = 0;
  editUserRecord.permissions.length = 0;
  editUser.value = false;
  newUser.value = false;
}

onMounted(() => {
  console.log("Onmounted triggered");
  getUsers();
  getRoles();
});

function clearSelectedUser() {
  editUserRecord.email = "";
  editUserRecord.username = "";
  showSelectUser.value = true;
  selectedUser.value = "";
}

async function getUserAccounts() {
  const result = await apiQuery("J24Auth", "useraccounts", {
    apiAction: "get",
  });
  console.log(result);
  for (const key in result) {
    for (const attrKey in result[key].Attributes) {
      result[key][result[key].Attributes[attrKey].Name] =
        result[key].Attributes[attrKey].Value;
    }
    result[key].title = result[key].email;
    result[key].value = result[key].Username;
  }
  userAccounts.length = 0;
  userAccounts.push(...result);
}

async function saveUser() {
  loading.value = true;
  var action = "add";
  if (editUser.value) {
    action = "update";
  }
  await apiQuery("J24Auth", "users", {
    apiAction: action,
    ...editUserRecord,
  });
  cancelEditAdd();
  getUsers();
  loading.value = false;
}
</script>

<template>
  <h1>Users Management</h1>
  <v-icon @click="newUserPressed()">mdi-plus-circle</v-icon>Add New
  <br />
  <!-- Add Edit Form -->
  <v-form v-if="editUser || newUser">
    <v-text-field
      v-model="editUserRecord.email"
      item-text="email"
      label="User Email"
    ></v-text-field>
    <template v-if="showSelectUser"
      ><v-select
        v-model="selectedUser"
        :items="userAccounts"
        return-object
        label="Select User Account"
      >
      </v-select>
    </template>
    <template v-if="editUserRecord.username">
      <v-table class="text-left">
        <thead>
          <th>Email</th>
          <th>User Status</th>
          <th>Email Verified</th>
        </thead>
        <tbody>
          <td>{{ editUserRecord.email }}</td>
          <td>{{ editUserRecord.UserStatus }}</td>
          <td>{{ editUserRecord.email_verified }}</td>
        </tbody>
      </v-table>
      <v-btn @click="clearSelectedUser()">Change User Selected</v-btn>
    </template>
    <h3>Roles</h3>
    <v-icon @click="addRole = true">mdi-plus-circle</v-icon>

    <!-- Add Role  -->
    <template v-if="addRole">
      <v-select
        v-model="addRoleScope"
        :items="customers"
        label="Choose Scope of Role"
      ></v-select>
      <v-select
        v-model="addRoleSelected"
        :items="roles"
        label="Choose Role"
      ></v-select>
      <v-btn @click="addRoleSave()">Add Role</v-btn
      ><v-btn @click="addRole = false">Cancel</v-btn>
    </template>
    <!-- List Roles -->
    <v-table>
      <thead class="text-left">
        <th>Scope</th>
        <th>Role Name</th>
        <th></th>
      </thead>
      <tbody>
        <tr
          v-for="(role, key) in editUserRecord.roles"
          :key="role"
          class="text-left"
        >
          <td>{{ role.scope }}</td>
          <td>{{ getRoleName(role.roleID) }}</td>
          <td>
            <v-btn @click="editUserRecord.roles.splice(key, 1)">Delete</v-btn>
          </td>
        </tr>
      </tbody>
    </v-table>
    <h3>Permissions</h3>
    <v-icon @click="addPermission = true">mdi-plus-circle</v-icon>

    <!-- Add Permission -->
    <template v-if="addPermission">
      <v-select
        v-model="addPermissionScope"
        :items="customers"
        label="Choose Scope of Permission"
      ></v-select>
      <v-select
        v-model="addPermissionApp"
        :items="apps"
        label="Choose App"
      ></v-select>
      <v-select
        v-model="addPermissionSelected"
        :items="permissionsFiltered"
        label="Choose Permission to add"
      ></v-select>
      <v-combobox
        v-model="addPermissionSelectedActions"
        :items="addPermissionActions"
        label="Choose Actions"
        multiple
      ></v-combobox>
      <v-btn @click="addPermissionSave">Add Permission</v-btn
      ><v-btn @click="addPermission = false">Cancel</v-btn>
    </template>
    <v-table>
      <thead class="text-left">
        <th>Scope</th>
        <th>App</th>
        <th>Permission Name</th>
        <th>Actions</th>
        <th></th>
      </thead>
      <tbody>
        <tr
          v-for="(permission, key) in editUserRecord.permissions"
          :key="permission"
          class="text-left"
        >
          <td>{{ permission.scope }}</td>
          <td>{{ permission.app }}</td>
          <td>{{ permission.permissionName }}</td>
          <td>{{ permission.actions }}</td>
          <td>
            <v-btn @click="editUserRecord.permissions.splice(key, 1)"
              >Delete</v-btn
            >
          </td>
        </tr>
      </tbody>
    </v-table>
    <v-btn @click="saveUser()">Save</v-btn
    ><v-btn @click="cancelEditAdd()">Cancel</v-btn>
  </v-form>
  <!-- List Users-->
  <v-table v-if="!newUser && !editUser">
    <thead class="text-left">
      <th>User Email</th>
      <th></th>
    </thead>
    <tbody v-if="users.length" class="text-left">
      <tr v-for="(user, key) in users" :key="user">
        <td>{{ user.email }}</td>
        <td><v-icon @click="editUserPressed(key)">mdi-pencil</v-icon></td>
      </tr>
    </tbody>
  </v-table>

  <!-- Loading Dialog -->
  <v-dialog v-model="loading" hide-overlay persistent>
    <v-card color="grey">
      <v-card-text>
        Loading
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
